export default "__VITE_ASSET__CdIrNsIP__"